<div
  id="{{ ppId }}"
  class="deleteButtonWrapper"
  [class.deleteButtonWrapper--disabled]="ppDisabled"
  [class.dragging]="ppDragging"
  (click)="action()"
  role="button"
  aria-label="Delete"
  [attr.aria-disabled]="ppDisabled || ppDragging || ppProcess"
>
  <pp-spinner [ppButton]="true" [ppHidden]="!ppProcess"></pp-spinner>

  @if (!ppProcess) {
    <pp-icon [ppSrc]="EIconPath.ICON_BIN_14" ppColor="inherit"></pp-icon>
  }
</div>
